import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, initialised, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (initialised && user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(email.trim(), password);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error || "Invalid credentials.");
    setSubmitting(false);
  }

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 py-16 bg-[#1A1514]">
      <div className="w-full max-w-md">
        <p className="text-[10px] tracking-[0.42em] uppercase text-ink-taupe text-center">Studio</p>
        <h1 className="mt-4 font-display text-4xl tracking-tight text-center text-ink-ivory">
          Cineglimpse · Atelier
        </h1>
        <p className="mt-4 text-sm text-center text-ink-ivory/60">
          Private access for the studio archive.
        </p>

        <form onSubmit={onSubmit} className="mt-12 space-y-8" data-testid="admin-login-form" noValidate>
          <label className="block">
            <span className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe">Email</span>
            <input
              data-testid="admin-login-email"
              type="email"
              className="field-underline mt-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label className="block">
            <span className="text-[10px] tracking-[0.32em] uppercase text-ink-taupe">Password</span>
            <input
              data-testid="admin-login-password"
              type="password"
              className="field-underline mt-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-300/90">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="luxe-btn w-full disabled:opacity-50"
          >
            {submitting ? "Authenticating…" : "Enter the atelier"}
          </button>
        </form>
      </div>
    </div>
  );
}
